import { FilterCheckboxItem } from '/entities/FilterCheckboxList';
import { IProject } from '/entities/Project';

export const mapProjectToFilterItem = (tags: IProject[]): FilterCheckboxItem[] => {
  return tags.map(({ _id, name }) => ({ id: _id, value: name, checked: false }));
};
